import tracker from '../../TrackingService';

export const Events = {
    clickedServiceCard: {
        Mixpanel: 'Clicked Review Service Card',
    },
};

/**
 * @param {object} eventData
 * @param {string} eventData.orgId
 * @param {string} eventData.gigId
 */
export const reportClickEvent = (eventData = {}) => {
    const isBusinessUser = !!eventData.orgId;

    tracker.sendMixPanelEvent({
        eventName: Events.clickedServiceCard.Mixpanel,
        eventPayload: {
            'Business User': isBusinessUser,
            'Business Org Id': eventData.orgId,
            'Gig Id': eventData.gigId,
        },
    });
};
